import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.031 6.063a.216.216 0 0 0-.219.218v1.094h4.376V6.281c0-.11-.11-.218-.22-.218zM8.5 6.28c0-.82.684-1.531 1.531-1.531h3.938c.82 0 1.531.71 1.531 1.531v1.094h1.75c.957 0 1.75.793 1.75 1.75v2.625H5V9.125c0-.957.766-1.75 1.75-1.75H8.5zM19 12.625v3.5c0 .984-.793 1.75-1.75 1.75H6.75c-.984 0-1.75-.766-1.75-1.75v-3.5h5.25v.875c0 .492.383.875.875.875h1.75a.88.88 0 0 0 .875-.875v-.875z"
    }, null, -1)
  ]))]))
}
export default { render: render }